import React from 'react'
import { ContactContainer, H4, ImageContact } from './styles'

const ContactMe = ( ) => {
  return (
    <ContactContainer>
      
      <H4>
        Contact Me
      </H4>

      <div>
        <a
          href="https://www.facebook.com/pablo.hernandezvizcarra/"
          target="_blank"
          rel="noopener noreferrer">
          <ImageContact
            src="/img/facebook.svg" 
            data-testid="element-img"
          />
        </a>
        <a
          href="https://www.linkedin.com/in/pablo-urbano-hernandez-vizcarra-5aa691184"
          target="_blank"
          rel="noopener noreferrer">
          <ImageContact
            src="/img/linkedin.svg" 
            data-testid="element-img"
          />
        </a>
        <a
          href="https://github.com/PabloHdzVizcarra"
          target="_blank"
          rel="noopener noreferrer">
          <ImageContact
            src="/img/github.svg" 
            data-testid="element-img"
          />
        </a>
        <a
          href="https://twitter.com/PabloHzVizcarra"
          target="_blank"
          rel="noopener noreferrer">
          <ImageContact
            src="/img/gorjeo.svg" 
            data-testid="element-img"
          />
        </a>
      </div>

    </ContactContainer>
  )
}

export default ContactMe
